import { atom } from "../../app-jotai";

export const aiDialogAtom = atom<{
  open: boolean;
  /** selected-text source material captured when the dialog was opened */
  sourceMaterial?: string;
}>({ open: false });
